import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { slugify } from "../../../custom_utils/helpers";
export const ExpandItem = (props)=>/*#__PURE__*/ _jsx("li", {
        className: "expand__item",
        children: /*#__PURE__*/ _jsxs("details", {
            className: "expand__wrap",
            children: [
                /*#__PURE__*/ _jsx("summary", {
                    className: "expand__button",
                    children: /*#__PURE__*/ _jsx("h3", {
                        className: "expand__title title--ms",
                        children: props.title
                    })
                }),
                props.child != null ? /*#__PURE__*/ _jsx("div", {
                    className: "expand__content richtext-block",
                    children: props.child
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "expand__content richtext-block",
                    dangerouslySetInnerHTML: {
                        __html: props.text
                    }
                })
            ]
        })
    }, slugify(props.innerKey));
